import React from 'react';
import type { TablePreviewStats } from './tablePreviewStats';

/**
 * Screen-reader-only metadata for PDF table export (excluded from html2canvas).
 */
const TableExportPdfMetadata: React.FC<{
    previewStats: TablePreviewStats;
    deepLinkUrl?: string;
    /** Scenario link URL(s) (e.g. "open in the Holistic Pricing Simulator"), appended as a
     * native, clickable PDF text line below the table - never rasterized/cut off by html2canvas. */
    scenarioLinkUrls?: string[];
    'data-test-id'?: string;
}> = ({ previewStats, deepLinkUrl, scenarioLinkUrls, 'data-test-id': dataTestId }) => (
    <div data-export-exclude data-export-table-deeplink className="sr-only" data-test-id={dataTestId}>
        <span data-export-table-preview-stats={JSON.stringify(previewStats)} aria-hidden />
        {deepLinkUrl ? (
            <span data-export-table-deeplink-url={deepLinkUrl} aria-hidden>
                Open in AskAsper
            </span>
        ) : null}
        {scenarioLinkUrls && scenarioLinkUrls.length > 0 ? (
            <span data-export-table-scenario-links={JSON.stringify(scenarioLinkUrls)} aria-hidden>
                Holistic Pricing Simulator
            </span>
        ) : null}
    </div>
);

export default TableExportPdfMetadata;
